import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";

import { reset } from "MODULES/users/actions";
import { LargeInput as FormInput, Save } from "MODULES/shared/components/Forms";
import { EMAIL, PASSWORD, PASSWORD_CONFIRMATION } from "APP_ROOT/constants";
import api from "APP_ROOT/api";
import { Col } from "react-bootstrap";
import { properCase } from "LIB/formatters/text";
import { RESET_PASSWORD_TOKEN } from "MODULES/users/constants";

function ResetPassword({ ...props }) {
  const [tenant, setTenant] = useState({});
  const passwordField = document.querySelector("#password");
  const passwordConfirmationField = document.querySelector(
    "#password_confirmation"
  );
  const handleClickPassword = () => {
    const type =
      passwordField.getAttribute("type") === PASSWORD ? "text" : PASSWORD;
    passwordField.setAttribute("type", type);
  };

  const handleClickPasswordConfirmation = () => {
    const type =
      passwordConfirmationField.getAttribute("type") === PASSWORD
        ? "text"
        : PASSWORD;
    passwordConfirmationField.setAttribute("type", type);
  };

  useEffect(() => {
    api.session.tenant().then(({ data }) => {
      setTenant(data);

      return function cleanup() {};
    });
  }, []);

  return (
    <div className="login">
      <div className="container-fluid">
        <div className="main">
          <div className="row">
            <Col md={4} mdOffset={4}>
              <div className="panel panel-default">
                <div className="panel-body">
                  <div className="text-center">
                    <img src={tenant && tenant.logo_url} alt="Logo" />
                  </div>
                  <br />
                  <h1 className="text-center margin-top-none">
                    Enter New Password
                  </h1>
                  <form onSubmit={props.handleSubmit}>
                    <Field
                      name={PASSWORD}
                      component={FormInput}
                      label={properCase(PASSWORD)}
                      addon={
                        <i
                          className="fa fa-fw fa-eye"
                          onClick={handleClickPassword}
                        />
                      }
                      type={PASSWORD}
                      required
                    />
                    <Field
                      name={PASSWORD_CONFIRMATION}
                      component={FormInput}
                      label={"Confirm Password"}
                      addon={
                        <i
                          className="fa fa-fw fa-eye"
                          onClick={handleClickPasswordConfirmation}
                        />
                      }
                      type={PASSWORD}
                      required
                    />
                    <br />
                    <div className="row">
                      <Col md={6} mdOffset={3}>
                        <Save {...props} icon="fa-unlock" text="Reset" />
                      </Col>
                    </div>
                  </form>
                </div>
              </div>
            </Col>
          </div>
        </div>
      </div>
    </div>
  );
}

ResetPassword.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loginError: PropTypes.string
};

const actions = { onSubmit: reset };

const validate = values =>
  validator(values, v => {
    v.validate(PASSWORD, PASSWORD_CONFIRMATION).satisfies(rules.required);
    v.validate(PASSWORD_CONFIRMATION).satisfies(rules.matches(PASSWORD));
  });

export default connect((state, props) => {
  const searchParams = new URLSearchParams(props.location.search);

  return {
    initialValues: {
      reset_password_token: searchParams.get(RESET_PASSWORD_TOKEN),
      email: searchParams.get(EMAIL)
    }
  };
}, actions)(
  reduxForm({
    form: "resetPassword",
    validate
  })(ResetPassword)
);



// WEBPACK FOOTER //
// ./app/modules/session/components/ResetPassword/ResetPassword.jsx